export const label = ({ theme: { colors } }) => ({
    fontSize: '16px',
    fontWeight: 500,
    letterSpacing: '0.15px',
    lineHeight: '25px',
    color: colors.blueGrey4,
    marginRight: '16px',
});
